shvenergy.tracking = (function ($) {
	"use strict";

	function track(event, category, action, label) {
		var eventData = {
			"event": event,
			"eventData": {
				"category": category,
				"action": action,
				"label": label
			}
		};

		var dataLayer = window.dataLayer;
		if (!dataLayer) {
			console.log("Tracking not enabled:", eventData);
			return;
		}

		dataLayer.push(eventData);
	}

	function trackEvent(category, action, label) {
		track("trackEvent", category, action, label);
	}

	function trackRawEventData(eventData) {
		var dataLayer = window.dataLayer;
		if (!dataLayer) {
			console.log("Tracking not enabled:", eventData);
			return;
		}

		dataLayer.push(eventData);
	}

	return {
		track: track,
		trackEvent: trackEvent,
		trackRawEventData: trackRawEventData
	};

})(jQuery);